import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Tape = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Tape' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,2 L22,2 L22,22 L2,22 L2,2 Z M19,12 C19,15.8659091 15.8659091,19 12,19 C8.13409091,19 5,15.8659091 5,12 C5,8.13409091 8.13409091,5 12,5 C15.8659091,5 19,8.13409091 19,12 L19,12 Z M12,9 C10.3455,9 9,10.3455 9,12 C9,13.6545 10.3455,15 12,15 C13.6545,15 15,13.6545 15,12 C15,10.3455 13.6545,9 12,9 Z' />
  </StyledIcon>
);
